import styled from '@emotion/styled';

export const MachinePricesFilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;
